import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';

import { TranslationLoaderService } from '@services';

export const translationResolver: ResolveFn<void> = async (route, state) => {
    const translationLoaderService = inject(TranslationLoaderService);
    await translationLoaderService.loadTranslationsAwaitable(route.data);
};
